<svg xmlns="http://www.w3.org/2000/svg" 
    width="22" 
    height="20" 
    viewBox="0 0 22 20" 
    fill="currentColor">
    <path 
    fill-rule="evenodd" 
    clip-rule="evenodd" 
    d="M7.25 4H16.75H22V10.59L19.59 13H16.75V15H14.75V13V11H16.75H18.76L20 9.76V6H16.75H5.25H2V9.75L3.25 11H5.25H7.25V13V15H5.25V13H2.42001L0 10.58V4H5.25V0H16.75V2H7.25V4ZM12.75 11H9.25V13H12.75V11ZM20 18H2V15.42L0 13.42V20H22V13.41L20 15.41V18Z" />
</svg>
